import React, { useEffect } from 'react'
import { Route, useLocation } from 'react-router-dom'

import useAuth from './auth/useAuth'

import LoaderComponent from './components/CommonComponents/LoaderComponent'

const RequireAuth = ({ children }) => {
  const { isLoading, isAuthenticated, login } = useAuth()
  const location = useLocation()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      login({ returnTo: `${location.pathname}${location.search}` })
    }
  }, [isLoading, isAuthenticated]) // eslint-disable-line

  if (isLoading || !isAuthenticated) {
    return <LoaderComponent />
  }

  return children
}

const ProtectedRoute = ({ component: Component, ...args }) => (
  <Route
    {...args}
    render={props => (
      <RequireAuth>
        <Component {...props} />
      </RequireAuth>
    )}
  />
)

export default ProtectedRoute
